module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/mapaDopravnichProudu@3x-e49da699f4399b085da5fa45018b6972.png";